module.exports = __webpack_public_path__ + "img/126.d47048d4.jpg";